import request from '@/utils/request';
import qs from 'qs';

const path = 'api/v1';

const createLabel = (data) => request({
  url: `${path}/label`,
  method: 'post',
  params: data,
  paramsSerializer: params => {
    return qs.stringify(params, { indices: false });
  }
});

const updateLabel = (data) => request({
  url: `${path}/label`,
  method: 'put',
  params: data
});

const getLabel = (data) => request({
  url: `${path}/label`,
  method: 'get',
  params: data
});

const deleteLabel = (data) => request({
  url: `${path}/label`,
  method: 'delete',
  data
});

const bulkCreateLabel = (data) => request({
  url: `${path}/labels`,
  method: 'post',
  data
});

export {
  createLabel,
  updateLabel,
  getLabel,
  deleteLabel,
  bulkCreateLabel,
};
